import { Flex, Image, useBreakpointValue } from '@chakra-ui/react';
import dodologo from '../assets/images/dododotlog.png';
import { useNavigate } from "react-router-dom";

function Header() {
    const imgSizeLogo = useBreakpointValue({ base: "40%", md: "20%" });

    const navigate = useNavigate();
        
    return (
        <Flex justifyContent="center" 
              alignItems="center" 
              p={6} 
              bgColor="#282c34" >
            <Image src={dodologo} width={imgSizeLogo} height="auto" onClick={() => navigate("/")}/>
        </Flex>
    );
}

export default Header;